module.exports = __webpack_public_path__ + "static/media/slide4-sk.cb4ba3f2.webp";